import React from "react";
import { Icon } from "antd";
import styles from "./levelSeeAll.scss";

const LevelSeeAll = ({ onClick }) => (
  <div className={styles.seeAllContainer}>
    <span onClick={onClick} role="button" tabIndex={0}>
      {"Vidi više"}
    </span>
    <Icon type="right" />
  </div>
);

export default LevelSeeAll;



// WEBPACK FOOTER //
// ./src/containers/ModulePage/LevelSeeAll/LevelSeeAll.tsx